import {
  firstNonEmpty,
  getConversationPhone,
  sanitizeDisplayValue,
} from './conversationIdentity';

export function normalizeUserListResponse(res) {
  const data = res?.data || {};
  const list = Array.isArray(data.list) ? data.list : [];
  return {
    list: list.map(normalizeChatUser),
    count: Number(data.count) || 0,
    pages: Number(data.pages) || 0,
    currentPage: Number(data.current_page) || 1,
    hasNext: Boolean(data.has_next),
    hasPrevious: Boolean(data.has_previous),
  };
}

export function normalizeChatUser(user) {
  if (!user || typeof user !== 'object') return user;

  const phone = getConversationPhone(user);
  const whatsappName = firstNonEmpty(
    user.whatsapp_name,
    user.name,
    user.user_name,
    user.profile_name,
    user.contact_name
  );

  return {
    ...user,
    phone_number: phone || sanitizeDisplayValue(user.phone_number) || '',
    whatsapp_name: whatsappName,
  };
}

export function normalizeChatCountsResponse(res) {
  const userCounts = res?.data?.user_counts || {};
  return {
    intervene: Number(userCounts.intervene) || 0,
    min_15: Number(userCounts.min_15) || 0,
    hrs_24: Number(userCounts.hrs_24) || 0,
    history: Number(userCounts.history) || 0,
    total: Number(userCounts.total) || 0,
  };
}

export function normalizeMessagesResponse(res) {
  const data = res?.data || {};
  return {
    messages: Array.isArray(data.data) ? data.data : [],
    totalCount: Number(data.total_count) || 0,
  };
}

export function markUserReadInList(users, phoneNumber) {
  if (!phoneNumber) return users;
  return users.map((user) =>
    `${user.phone_number}` === `${phoneNumber}`
      ? { ...user, not_read_count: 0 }
      : user
  );
}
